import Chart from '../../../components/Chart/index';
import * as Styled from '../Dashboard.styles';
import { theme } from '../../../styles/theme';
import * as dayjs from 'dayjs';
import { Typography } from '@material-ui/core';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { transactionsFetchAction } from '../../../store/fetchActions/transactionsActions';
import { listNewUsersFetchAction } from '../../../store/fetchActions/listUsersActions';
import Table from '../../../components/Table/Table';

export default function ChartContainer() {
  const { mainColor, secondaryColor } = theme.colors;

  const {
    movimentacaoData,
    errorMessage,
    errorDailyMovements,
    loadingDailyMovements,
  } = useSelector((state) => state.dailyMovements);

  const { dataListUsers, errorListUsers, messageListUsers, loadingListUsers } =
    useSelector((state) => state.listUsers);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(transactionsFetchAction());
    dispatch(listNewUsersFetchAction());
  }, []);

  const {
    transactionsData: { TRANSACOES },
  } = useSelector((state) => state.transactions);

  const { dataListNewApprovedUsers } = useSelector((state) => state.listUsers);

  const defaultChartData = [0, 0, 0, 0, 0, 0, 0];

  const formatDates = (dates) => {
    var formattedDataArray = [];
    formattedDataArray = dates.map((date) => {
      return dayjs(date).format('DD/MM/YYYY');
    });

    return formattedDataArray;
  };

  const headerMovimentacao = [
    {
      id: 'hora',
      name: 'HORA',
      align: 'left',
    },
    {
      id: 'operacao',
      name: 'OPERAÇÃO',
      align: 'left',
    },
    {
      id: 'valor',
      name: 'VALOR',
      align: 'right',
    },
    {
      id: 'status',
      name: 'STATUS',
      align: 'center',
    },
  ];

  const headerEntradaCliente = [
    {
      id: 'data',
      name: 'DATA',
      align: 'left',
    },
    {
      id: 'nome',
      name: 'NOME',
      align: 'left',
    },
    {
      id: 'status',
      name: 'STATUS',
      align: 'center',
    },
  ];

  const bodyMovimentacao =
    movimentacaoData?.length > 0 &&
    movimentacaoData?.map((item) => {
      return {
        data: [
          { info: item.HORA, align: 'left' },
          { info: item.OPERACAO, align: 'left' },
          { info: `R$ ${formatMoney(item.VALOR)}`, align: 'right' },
          {
            info:
              item.STATUS === '1' ? (
                <Styled.IconContainer
                  iconColor={'#EC2A00'}
                  backgroundColor={'#EC2A001A'}
                >
                  <ArrowUpward />
                </Styled.IconContainer>
              ) : (
                <Styled.IconContainer
                  iconColor={'#00EC2A'}
                  backgroundColor={'#00EC2A26'}
                >
                  <ArrowDownward />
                </Styled.IconContainer>
              ),
          },
        ],
      };
    });

  const bodyEntradaCliente =
    dataListUsers?.length > 0 &&
    dataListUsers?.map((item, index) => {
      return {
        data: [
          { info: item.DATA, align: 'left' },
          { info: item.NOME, align: 'left' },
          {
            info: item.CODSTATUS ? (
              <StatusContainer
                code={item.CODSTATUS}
                description={item.STATUS}
              ></StatusContainer>
            ) : (
              '-----'
            ),
            align: 'center',
          },
        ],
      };
    });

  let dates = TRANSACOES ? Object.keys(TRANSACOES.DEBITO).reverse() : [];
  let formattedDates = formatDates(dates);
  let debitData = TRANSACOES
    ? Object.values(TRANSACOES.DEBITO).reverse()
    : defaultChartData;
  let creditData = TRANSACOES
    ? Object.values(TRANSACOES.CREDITO).reverse()
    : defaultChartData;

  const chartData = {
    title: 'Transações',
    secondaryTitle: 'Últimos 7 dias',
    labels: formattedDates,
    datasets: [
      {
        label: 'Crédito',
        backgroundColor: `${secondaryColor}`,
        data: creditData,
        barPercentage: 0.6,
      },
      {
        label: 'Débito',
        backgroundColor: `${mainColor}`,
        data: debitData,
        barPercentage: 0.6,
      },
    ],
  };

  const secondChartData = {
    title: 'Entrada de clientes',
    secondaryTitle: 'Últimos 7 dias',
    labels: formattedDates,
    datasets: [
      {
        label: 'Aprovados',
        backgroundColor: `#5C71BB`,
        data: dataListNewApprovedUsers,
        barPercentage: 0.6,
        borderWidth: 1.5,
      },
    ],
  };

  return (
    <Styled.ChartContainer>
      <Styled.ChartGrid>
        <Styled.ChartElement>
          <Styled.Header>
            <Typography variant="h5">{chartData.title}</Typography>
            <Typography variant="h6">{chartData.secondaryTitle}</Typography>
          </Styled.Header>
          <Chart
            title={chartData.subtitle}
            labels={chartData.labels}
            data={chartData.datasets}
            containerHeight={'24.792vw'}
          />{' '}
        </Styled.ChartElement>
        <Styled.ChartElement>
          <Styled.Header>
            <Typography variant="h5">{secondChartData.title}</Typography>
            <Typography variant="h6">
              {secondChartData.secondaryTitle}
            </Typography>
          </Styled.Header>
          <Chart
            title={secondChartData.subtitle}
            labels={secondChartData.labels}
            data={secondChartData.datasets}
            moneyFormat={false}
            containerHeight={'24.792vw'}
            displayLegend={false}
          />
        </Styled.ChartElement>
      </Styled.ChartGrid>
      <Styled.ChartTableGrid>
        <Styled.ChartElement>
          <Styled.TableContainer>
            <Styled.TableHeader>
              <Typography variant="h5">{'Movimentação do dia'}</Typography>
              <Typography variant="h6">
                QUANTIDADE:{' '}
                <Styled.TextBold>{`${movimentacaoData?.length} ${
                  movimentacaoData?.length === 1
                    ? 'movimentação'
                    : 'movimentações'
                }`}</Styled.TextBold>
              </Typography>
            </Styled.TableHeader>
            <Table
              loading={loadingDailyMovements}
              error={errorDailyMovements}
              errorMessage={errorMessage}
              maxHeight={'300px'}
              header={headerMovimentacao}
              body={bodyMovimentacao}
            />
          </Styled.TableContainer>
        </Styled.ChartElement>
        <Styled.ChartElement>
          <Styled.TableContainer>
            <Styled.TableHeader>
              <Typography variant="h5">{'Entrada de clientes'}</Typography>
              <Typography variant="h6">
                QUANTIDADE:{' '}
                <Styled.TextBold>{`${dataListUsers?.length} ${
                  dataListUsers?.length === 1 ? 'entrada' : 'entradas'
                }`}</Styled.TextBold>
              </Typography>
            </Styled.TableHeader>
            <Table
              loading={loadingListUsers}
              error={errorListUsers}
              errorMessage={messageListUsers}
              maxHeight={'300px'}
              header={headerEntradaCliente}
              body={bodyEntradaCliente}
            />
          </Styled.TableContainer>
        </Styled.ChartElement>
      </Styled.ChartTableGrid>
    </Styled.ChartContainer>
  );
}
